__turbopack_context__.v({
  "capabilities": "styles-module__gNMdpa__capabilities",
  "heading": "styles-module__gNMdpa__heading",
  "wrapper": "styles-module__gNMdpa__wrapper",
});
